module.exports = __webpack_public_path__ + "img/Groupe 529.27a51c28.svg";